import { render } from "./theme37.vue?vue&type=template&id=192c6f35&scoped=true"
import script from "./theme37.vue?vue&type=script&lang=js"
export * from "./theme37.vue?vue&type=script&lang=js"

import "./theme37.vue?vue&type=style&index=0&id=192c6f35&lang=less&scoped=true"
script.render = render
script.__scopeId = "data-v-192c6f35"

export default script